module.exports = __webpack_public_path__ + "img/fa-flag.af31dbe0.svg";